export const downloadFile = (data: any, filename: string ) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

}

export const fileDateTag = () => new Date().toISOString().slice(0, 16).replace(/[-T:]/g, '');
